import React from 'react';

const Inner = (props) => (
    <div className="inner">
        <img src="/signup/images/footer.png" width="100%"/>
    </div>
)

export default Inner